
import type { PropType } from 'vue'
import type { ExplainMessages } from '../../models'

import { defineComponent, ref } from 'vue'

import { SearchModeEnum } from '../../enums/search-mode.enum'
import { EpbToggle } from '../shared/epb-toggle'

export default defineComponent({
  name: 'ExplainSearchModeToggle',
  components: {
    EpbToggle,
  },
  props: {
    messages: {
      type: Object as PropType<ExplainMessages['search']['mode']>,
      required: true,
    },
  },
  setup(props) {
    const baseClass = 'epb-explain-search-mode-toggle'
    const modeOptions = [
      {
        content: props.messages[SearchModeEnum.KEYWORD].title.toUpperCase(),
        id: SearchModeEnum.KEYWORD,
        tooltip: props.messages[SearchModeEnum.KEYWORD].tooltip,
      },
      {
        content: props.messages[SearchModeEnum.HYBRID].title.toUpperCase(),
        id: SearchModeEnum.HYBRID,
        tooltip: props.messages[SearchModeEnum.HYBRID].tooltip,
      },
      {
        content: props.messages[SearchModeEnum.SEMANTICS].title.toUpperCase(),
        id: SearchModeEnum.SEMANTICS,
        tooltip: props.messages[SearchModeEnum.SEMANTICS].tooltip,
      },
    ]

    const mode = ref(modeOptions[0].id)

    return { baseClass, mode, modeOptions }
  },
})
